import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/** Represents the conversation message attachments component. */
// TODO: [TEAMS-10722] Implement attachments component
export const ConversationMessageAttachments = ({ attachments, }) => {
    return _jsx(_Fragment, {});
};
